import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TRACKER_CREATE_ACTIVATION_CLICK } from '../../tracking';
import { RbacPermissions } from '../../../../core/interfaces/user';
import {
  SessionTrackingAngularticsService
} from '../../../../core/services/session-tracking-angulartics.service';
import { HdRbacButton } from '../../../../components';
import HdShortcut from '../../../../a11y/shortcuts/components/shortcut/HdShortcut';
import useKeyboardShortcutListener from '../../../../a11y/shortcuts/hooks/useKeyboardShortcutListener';
import useService from '../../../../injector/hooks/useService';

export function CreateActivationButton() {
  const navigate = useNavigate();
  const _creationTrackingAngularticsService = useService(SessionTrackingAngularticsService);

  const onCreateActivationClick = () => {
    _creationTrackingAngularticsService.startSessionAndTrack({
      action: TRACKER_CREATE_ACTIVATION_CLICK
    });

    navigate('/activation/create');
  };

  useKeyboardShortcutListener(
    () => {
      onCreateActivationClick();
    },
    'activation.create',
    { priority: 0, terminal: 'match', inputs: true }
  );

  return (
    <HdRbacButton
      icon='plus'
      rbacPermission={RbacPermissions.ACTIVATION_CREATE}
      type='button'
      onClick={onCreateActivationClick}
      dataId='create-activation'
      className="text-label-small"
      tooltipContent={<HdShortcut command='activation.create' />}
    >
      Create Activation
    </HdRbacButton>
  );
}
